<section class="bk-panel fr" aria-labelledby="fr-title">
  <header class="fr__head">
    <div class="fr__intro">
      <h2 class="bk-eyebrow" id="fr-title">Failed numbers</h2>
      <p class="fr__sub">
        <strong>{{ formatCount(shownTotal) }}</strong>
        {{ shownTotal === 1 ? "number was" : "numbers were" }} not reached. Each
        row says why, so you can fix the number or try it again.
      </p>
    </div>
    <ng-container
      *hasPermission="{ category: 'CAMPAIGN_MANAGEMENT', permission: 'export-campaign-reports' }"
    >
      <button
        type="button"
        class="bk-btn bk-btn--ghost"
        [disabled]="exporting"
        [attr.aria-busy]="exporting || null"
        (click)="download()"
      >
        <span class="bk-sym" aria-hidden="true">download</span>
        {{ exporting ? "Preparing file…" : "Download failed numbers" }}
      </button>
    </ng-container>
  </header>

  @if (exportError) {
    <p class="fr__note" aria-hidden="true">{{ exportError }}</p>
  }
  <!-- Persistent live regions for the note: failures as alerts, the rest politely -->
  <span class="bk-sr-only" aria-live="polite">{{ exportFailed ? "" : exportError }}</span>
  <span class="bk-sr-only" role="alert">{{ exportFailed ? exportError : "" }}</span>

  @switch (state) {
    @case ("loading") {
      <div class="fr__skel" role="status">
        <span class="bk-sr-only">Loading failed numbers</span>
        @for (row of [1, 2, 3, 4]; track row) {
          <span class="bk-skel" style="height: 14px" aria-hidden="true"></span>
        }
      </div>
    }
    @case ("error") {
      <div class="fr__empty">
        <p class="fr__empty-body">
          The failed numbers could not be loaded. Check your connection and try again.
        </p>
        <button type="button" class="bk-btn bk-btn--ghost" (click)="retry()">Try again</button>
      </div>
    }
    @default {
      @if (rows.length) {
        <div class="fr__scroll">
          <table class="bk-log fr__table">
            <thead>
              <tr>
                <th scope="col">Number</th>
                <th scope="col" class="col-name">Name</th>
                <th scope="col" class="col-message">Message</th>
                <th scope="col">Reason</th>
                <th scope="col" class="num col-when">Time</th>
              </tr>
            </thead>
            <tbody>
              @for (row of rows; track $index) {
                <tr>
                  <td class="fr__number">{{ row.mobileNumber || "—" }}</td>
                  <td class="col-name fr__name">{{ row.fullName || "—" }}</td>
                  <td class="col-message quiet fr__message">{{ subjectOf(row) || "—" }}</td>
                  <td>
                    <app-status [text]="row.deliveryStatus || 'Failed'" status="failed" />
                  </td>
                  <td class="num quiet col-when">{{ formatWhen(row.timeStamp) }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>

        @if (totalPages > 1) {
          <div class="fr__pagination">
            <app-pagination
              [currentPage]="page"
              [totalPages]="totalPages"
              [totalItems]="total ?? undefined"
              [pageSize]="size"
              [loading]="false"
              (changePage)="changePage($event)"
              (onNext)="changePage(page + 1)"
              (onPrev)="changePage(page - 1)"
              (pageSizeChange)="changeSize($event)"
            />
          </div>
        }
      } @else {
        <div class="fr__empty">
          <p class="fr__empty-body">
            The individual numbers are not listed yet. Delivery receipts can take
            a few minutes to arrive after a send; check back shortly.
          </p>
        </div>
      }
    }
  }
</section>
